import React, { useState } from "react";
import { Dialog } from "orion-components/CBComponents";
import { Button } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { closeDialog } from "orion-components/AppState/Dialog/actions";
import DeviceTree from "../../DeviceTree/DeviceTree";
import { deviceGroupsService } from "client-app-core";
import { Translate } from "orion-components/i18n";
import { getDir } from "orion-components/i18n/Config/selector";

const styles = {
	dialogSX: {
		"& .MuiDialogContent-root": {
			padding: "33px 41px 40px 41px !important",
			width: "455px !important",
			height: "526px !important",
			overflow: "hidden"
		}
	},
	addDevicesToGroupWrapper: (dir) => ({
		...(dir === "ltr" && { textAlign: "left" }),
		...(dir === "rtl" && { textAlign: "right" }),
		fontFamily: "Roboto, sans-serif",
		fontWeight: 500, // 'medium' corresponds to font weight 500
		fontSize: "14px",
		lineHeight: "19px",
		letterSpacing: "0px",
		color: "#FFFFFF",
		opacity: 1,
		marginBottom: 3
	}),
	chooseGroup: (dir) => ({
		...(dir === "ltr" && { textAlign: "left" }),
		...(dir === "rtl" && { textAlign: "right" }),
		fontFamily: "Roboto, sans-serif",
		fontWeight: 400, // 'normal' corresponds to font weight 400
		fontSize: "11px",
		lineHeight: "15px",
		letterSpacing: "0px",
		color: "#8B8B8B",
		opacity: 1,
		marginBottom: 42.43
	}),
	cancel: (dir) => ({
		...(dir === "ltr" && { textAlign: "left" }),
		...(dir === "rtl" && { textAlign: "right" }),
		color: "#BBBFC4",
		fontWeight: 500,
		fontSize: "12px",
		lineHeight: "14px",
		fontFamily: "Roboto, sans-serif",
		letterSpacing: "0px",
		opacity: 1,
		height: "36px"
	}),
	save: (dir) => ({
		...(dir === "ltr" && { textAlign: "left" }),
		...(dir === "rtl" && { textAlign: "right" }),
		fontWeight: 500,
		fontSize: "12px",
		lineHeight: "14px",
		fontFamily: "Roboto, sans-serif",
		letterSpacing: "0px",
		opacity: 1,
		color: "#FFFFFF",
		height: "36px",
		borderRadius: 8
	})
};

const AddToDeviceGroupDialog = ({ selectedRows, resetSelectedRows }) => {
	const open = useSelector((state) => state?.appState?.dialog?.openDialog === "addToDeviceGroup-dialog");
	const dir = useSelector((state) => getDir(state));

	const [selectedNodes, setSelectedNodes] = useState([]);

	const dispatch = useDispatch();

	const handleCloseDialog = () => {
		dispatch(closeDialog("addToDeviceGroup-dialog"));
	};

	const handleSave = () => {
		const devices = [];
		selectedRows.forEach((element) => {
			devices.push({ type: element.entityType, id: element.id });
		});

		selectedNodes.forEach((id) => {
			deviceGroupsService.addDevices(id, { devices }, (err) => {
				if (err) {
					const errorMessage = {
						message: "Failed to add devices to the device groups.",
						error: err
					};
					console.error("Error Details:", errorMessage);
				}
				setSelectedNodes([]);
			});
		});
		resetSelectedRows();
		handleCloseDialog();
	};

	const getSelectedNodes = (id) => {
		setSelectedNodes((prevArray) => {
			if (prevArray.includes(id)) {
				// If the ID exists, remove it
				return prevArray.filter((existingId) => existingId !== id);
			} else {
				// If the ID doesn't exist, add it
				return [...prevArray, id];
			}
		});
	};

	return (
		<Dialog open={open} dialogSX={styles.dialogSX} actionContainerPropStyles={{ outline: "none" }} actions={false} data-testid="orion-components-device-manager-device-view-components-add-to-device-group-dialog-dialog">
			<div>
				<div style={styles.addDevicesToGroupWrapper(dir)}>
					<Translate value="global.deviceManager.deviceView.components.addToDeviceGroupDialog.addDevicesToGroups" />
				</div>
				<div style={styles.chooseGroup(dir)}>
					<Translate value="global.deviceManager.deviceView.components.addToDeviceGroupDialog.chooseGroups" />
				</div>
				<div style={{ height: 256 }}>
					<DeviceTree addToDeviceGroup={true} readOnly={true} getSelectedNodes={getSelectedNodes} />
				</div>
				{/* Dialog actions */}
				<div
					style={{
						display: "flex",
						justifyContent: "flex-end",
						alignItems: "center",
						marginTop: 48.25
					}}
				>
					<div style={{ display: "flex", gap: "10px" }}>
						<Button variant="text" style={styles.cancel(dir)} onClick={handleCloseDialog} data-testid="orion-components-device-manager-device-view-components-add-to-device-group-dialog-button">
							<Translate value="global.deviceManager.deviceView.components.addToDeviceGroupDialog.cancel" />
						</Button>
						<Button
							variant="contained"
							style={styles.save(dir)}
							onClick={handleSave}
							disabled={!selectedNodes?.length} data-testid="orion-components-device-manager-device-view-components-add-to-device-group-dialog-button-2"
						>
							<Translate value="global.deviceManager.deviceView.components.addToDeviceGroupDialog.save" />
						</Button>
					</div>
				</div>
			</div>
		</Dialog>
	);
};

export default AddToDeviceGroupDialog;
